import React from 'react';

import Landing from './pages/Landing';

function App(): React.ReactElement {
  return <Landing/>;
}

export default App;
